/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SaleJson } from './SaleJson';
import {
    SaleJsonFromJSON,
    SaleJsonFromJSONTyped,
    SaleJsonToJSON,
} from './SaleJson';

/**
 * 
 * @export
 * @interface SalesJsonContent
 */
export interface SalesJsonContent {
    /**
     * 
     * @type {Array<SaleJson>}
     * @memberof SalesJsonContent
     */
    sales?: Array<SaleJson>;
}

/**
 * Check if a given object implements the SalesJsonContent interface.
 */
export function instanceOfSalesJsonContent(value: object): value is SalesJsonContent {
    let isInstance = true;

    return isInstance;
}

export function SalesJsonContentFromJSON(json: any): SalesJsonContent {
    return SalesJsonContentFromJSONTyped(json, false);
}

export function SalesJsonContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesJsonContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sales': !exists(json, 'sales') ? undefined : ((json['sales'] as Array<any>).map(SaleJsonFromJSON)),
    };
}

export function SalesJsonContentToJSON(value?: SalesJsonContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sales': value.sales === undefined ? undefined : ((value.sales as Array<any>).map(SaleJsonToJSON)),
    };
}

